/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/manage.scss';
import Tab from '../../component/Inc/Tab';
import Calendar from '../../component/Inc/Calendar';
import Paging from '../../component/Inc/Paging';
import Upload from '../../component/Inc/Upload';
function Birthday() {
  const [tabIdx, setTabIdx] = useState(0);
  const [modalAlert, setModalAlert] = useState(0);

  const tab01 = [
    {title: '전체', value: 0},
    {title: '내근직', value: 1},
    {title: '교사', value: 2}
  ];
  return (
    <main className="com_container p_manage_birthday">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu9_10 active">이달의 생일</h2>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <Calendar />
          </section>
          <div className="box_wrap">
            <section className="box">
              <div className="com_board_list__top">
                <Tab data={tab01} tab={tabIdx} setTab={setTabIdx} tabStyle="fit_cont" />
              </div>
              <table className="com_board_list">
                <colgroup>
                  <col width="60" />
                  <col width="130" />
                  <col width="130" />
                  <col width="130" />
                  <col width="auto" />
                  <col width="130" />
                  <col width="80" />
                </colgroup>
                <thead>
                  <tr>
                    <th>
                      <input type="checkbox" id="chkAll" className="com_chk" />
                      <label htmlFor="chkAll"></label>
                    </th>
                    <th>생년월일</th>
                    <th>이름</th>
                    <th>소속</th>
                    <th>주소</th>
                    <th>전화번호</th>
                    <th>상세보기</th>
                  </tr>
                </thead>
                <tbody>
                  {[...Array(9)].map((_, idx) => (
                    <tr key={idx}>
                      <td>
                        <input type="checkbox" id={`chk${idx}`} className="com_chk" />
                        <label htmlFor={`chk${idx}`}></label>
                      </td>
                      <td>2022-08-25</td>
                      <td>
                        <button className="btn_link">김요청103</button>
                      </td>
                      <td>교육부</td>
                      <td>서울시</td>
                      <td>010-1234-3214</td>
                      <td>
                        <button className="btn_link blue">보기</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <Paging />
            </section>
            <section className="box">
              <div className="detail_tit dot">받는사람</div>
              <div className="com_comment_wrap">
                <div className="multiple_file_wrap">
                  <div className="item">
                    <button className="btn_del_file"></button>
                    <span className="tit">홍길동</span>
                  </div>
                  <div className="item">
                    <button className="btn_del_file"></button>
                    <span className="tit">홍길동</span>
                  </div>
                  <div className="item">
                    <button className="btn_del_file"></button>
                    <span className="tit">홍길동</span>
                  </div>
                </div>
                <div className="com_input_wrap flex_row">
                  <input type="text" className="input" placeholder="제목 입력" />
                </div>
                <textarea className="textarea" placeholder="내용을 입력해주세요"></textarea>
              </div>
              <div className="com_input_upload">
                <Upload title="파일 등록" className="com_btn gray s wl" />
                <p className="file">
                  <span className="txt">File name.pdf</span>
                  <button type="button" className="btn_del_file" onClick={() => {}}></button>
                  <button type="button" className="btn_down" onClick={() => {}}></button>
                </p>
              </div>
              <hr className="com_divider" />
              <div className="com_btn_wrap  center bottom">
                <button className="com_btn orange xs">보내기</button>
              </div>
            </section>
          </div>
        </section>
      </div>
    </main>
  );
}

export default Birthday;
